class XebecCartHandler {
  constuctor() {}

  addToCart(itemQty) {
    const items = Object.keys(itemQty).map((item) => ({
      'id': item,
      'quantity': itemQty[item]
    }))
    
    const formData = { items };

    this.log("addToCart", formData)
    
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json()
    })
      .then((cartData) => {
        console.debug(cartData)
      })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  log(id, val) {
    console.debug("XebecCartHandler::" + id, val)
  }
}

class XebecVariantHandler {
  constructor(parentEl) {
    this.cartHandler = new XebecCartHandler();
    
    this.parentEl = parentEl;
    this.selectedVariantId = null;
    this.selectedVariantData = null;
    this.selectedVariantBundleItems = null;

    this.priceWrapperSelector = ".title-price-wrapper.pdp";
    
    this.basePriceQuerySelector = ".overridable-price__base-price-wrapper__base-price"; 
    this.currentPriceQuerySelector = ".overridable-price__current-price-wrapper__current-price"; 

    this.addToCartBtnSelector = "#xebec-add-to-cart-btn"
  }

  updateVariant(id, variantData, bundleItems = []) {
    this.log("updateVariant", id);
    this.log("updateVariant", variantData)
    this.log("updateVariant", "bundleItems", bundleItems)

    const productForm = this.parentEl.querySelector("xebec-product-form");
    const basePrice = variantData.compare_at_price;
    const currentPrice = variantData.price;

    this.selectedVariantId = id;
    this.selectedVariantData = variantData;
    
    this.setBasePrice(basePrice);
    this.setCurrentPrice(currentPrice);

    console.debug("parentEl", this.parentEl)
    console.debug("product form", this.parentEl.querySelector("xebec-product-form"))

    const bundleItemsQty = bundleItems.reduce((c,v) => {
      c[v] = (c[v] || 0) + 1;
      return c;
    }, {})

    this.selectedVariantBundleItems = bundleItemsQty;
    
    if (variantData.available)
      this.enableCartBtn();
    else
      this.disableCartBtn();
  }

  addToCart() {
    this.log("addToCart", this.selectedVariantId)

    const isBundle = Object.keys(this.selectedVariantBundleItems).length > 0
    const items = isBundle ? this.selectedVariantBundleItems : { [this.selectedVariantId]: 1 }

    const self = this;

    this.disableCartBtn();
    this.startLoading();
    
    this.cartHandler.addToCart(items)
      .finally(async () => {
        const drawer = document.querySelector('cart-drawer');

        if (drawer)
          await drawer.updateCartDrawer()
            .then(() => this.log("addToCart", "Updated cart."))
            .catch((err) => this.log("addToCart", "Error caught trying to update cart.", err))
        
        this.endLoading();
        this.enableCartBtn();
       /* 🔗  AUTO-REDIRECT AFTER SUCCESS ---------------------------------- */
   const targetUrl = `/pages/snap-config-flow`;
   window.location.assign(targetUrl);   // or  location.href = targetUrl;
      });
  }
  
  disableCartBtn() {
    this.log("disableCartBtn", "disabling the cart button")
    
    const cartBtn = this.getAddToCartBtn();

    if (cartBtn) 
      cartBtn.disabled = true;
  }

  enableCartBtn() {
    this.log("enableCartBtn", "enabling the cart button")
    
    const cartBtn = this.getAddToCartBtn();

    if (cartBtn) 
      cartBtn.disabled = false;
  }

  startLoading() {
    const cartBtn = this.getAddToCartBtn();

    if (cartBtn)
      cartBtn.classList.add('loading');
  }

  endLoading() {
    const cartBtn = this.getAddToCartBtn();

    if (cartBtn)
      cartBtn.classList.remove('loading');
  }

  getBasePriceSpans() {
    return Array.from(document.querySelectorAll(this.priceWrapperSelector))
      .map((el) => el.querySelector(this.basePriceQuerySelector))
  }

  getCurrentPriceSpans() {    
    return Array.from(document.querySelectorAll(this.priceWrapperSelector))
      .map((el) => el.querySelector(this.currentPriceQuerySelector))
  }

  getAddToCartBtn() {
    return document.querySelector(this.addToCartBtnSelector)
  }

  getFormattedPrice(priceInCents) {
    const formattedPrice = "$" + priceInCents/100;

    this.log("getFormattedPrice", priceInCents, formattedPrice)
    
    return formattedPrice
  }

  setBasePrice(priceInCents) {
    this.log("setBasePrice", priceInCents)
    
    const basePriceSpans = this.getBasePriceSpans();
    
    if (priceInCents && basePriceSpans.length > 0) 
      basePriceSpans.forEach((basePriceSpan) => basePriceSpan.textContent = this.getFormattedPrice(priceInCents));
  }

  setCurrentPrice(priceInCents) {
    this.log("setCurrentPrice", priceInCents)
    
    const currentPriceSpans = this.getCurrentPriceSpans();

    if (priceInCents && currentPriceSpans.length > 0) 
      currentPriceSpans.forEach((currentPriceSpan) => currentPriceSpan.textContent = this.getFormattedPrice(priceInCents));
  }

  async updateCart() {
    const drawer = document.querySelector('cart-drawer');

    if (drawer)
      return drawer.updateCartDrawer()
        .catch((err) => {})
  }
  
  // updateBundle(itemId, qty) {
  //   this.log("updateBundle", itemId, qty);

  //   const bundleItem = document.createElement("bundle")
  //   bundleItem.setAttribute("data-item-id", itemId)

  //   const productForm = document.createElement("form");
  //   productForm.setAttribute("method", "post");
  //   productForm.setAttribute("action", "/cart/add");
  //   productForm.setAttribute("id", "bundle-product-" + itemId);
  //   productForm.setAttribute("enctype", "multipart/form-data");
  //   productForm.setAttribute("data-productid", this.selectedVariantId);
  //   productForm.setAttribute("novalidate", "novalidate");
  //   productForm.setAttribute("data-type", "add-to-cart-form");

  //   const idInput = document.createElement("input");
  //   idInput.setAttribute("type", "hidden");
  //   idInput.setAttribute("name", "id");
  //   idInput.setAttribute("data-productid", this.selectedVariantId);
  //   idInput.setAttribute("quantity", qty || 1);
  //   idInput.setAttribute("value", itemId);

  //   const qtyInput = document.createElement("input");
  //   qtyInput.setAttribute("type", "hidden");
  //   qtyInput.setAttribute("name", "qty");
  //   qtyInput.setAttribute("min", qty || 1);
  //   qtyInput.setAttribute("value", qty || 1);

  //   const productIdInput = document.createElement("input");
  //   productIdInput.setAttribute("type", "hidden");
  //   productIdInput.setAttribute("name", "product-id");
  //   productIdInput.setAttribute("value", this.selectedVariantId);

  //   productForm.appendChild(idInput);
  //   productForm.appendChild(qtyInput);
  //   productForm.appendChild(productIdInput);
  //   bundleItem.appendChild(productForm);
    
  //   this.parentEl.appendChild(bundleItem);
  // }

  // removeBundles() {
  //   Array.from(this.parentEl.querySelectorAll("bundle")).forEach((el) => el.remove())
  // }

  log(id, ...vals) {
    console.debug("XebecVariantHandler::" + id, vals)
  }
}

class XebecVariantOptions extends HTMLElement {
  constructor() {
    super();

    this.handler = new XebecVariantHandler(this);
    this.variantsById = {}
    this.variantElementsById = {}
    this.bundlesById = {}
  }

  connectedCallback() {
    const variantData = this.getData();
    const variants = variantData.variants;
    const bundles = variantData.bundles;

    this.bundlesById = bundles;

    variants.forEach((variant) => {
      this.variantsById[variant.id] = variant;
    })

    const variantContainer = document.createElement("div");
    variantContainer.classList.add("variant-container")
    
    const variantEls = Object.values(this.variantsById).map((variant) => this.createVariant(variant))

    for (const variantEl of variantEls) {
      this.variantElementsById[variantData.id] = variantEl;
      variantContainer.appendChild(variantEl);
    };

    const urlVariant = this.getQueryStringVariant();
    const cartBtn = this.createCartBtn();

    this.appendChild(variantContainer);
    this.appendChild(cartBtn)

    if (urlVariant && this.variantsById[urlVariant]) {
      this.onVariantSelect(urlVariant);
    } else if (variants.length > 0) {
      this.onVariantSelect(variants[0].id)
    }
  }

  createCartBtn() {
    this.log("createCartBtn", "creating cart button");
    
    const cartBtn = document.createElement("button");

    cartBtn.setAttribute("type", "button");
    cartBtn.setAttribute("name", "add");
    cartBtn.setAttribute("class", "product-form__submit button button--full-width button--primary");
    cartBtn.setAttribute("id", "xebec-add-to-cart-btn");

    cartBtn.textContent = "Add to cart";

    cartBtn.addEventListener('click', (evt) => this.handleAddToCart());

    return cartBtn;
  }
  
  createVariant(variantData) {
    this.log("variantData", variantData)

    const variantEl = new XebecVariant();
    variantEl.initVariant(variantData);
    variantEl.setAttribute("data-variant-id", variantData.id)
    variantEl.addEventListener('click', (evt) => this.onVariantSelect(variantData.id))

    return variantEl;
  }

  handleAddToCart() {
    this.log("handleAddToCart", "adding to cart");

    this.handler.addToCart();
  }

  onVariantSelect(variantId) {
    this.log("onVariantSelect", variantId)

    const variantSelector = `xebec-variant[data-variant-id='${variantId}']`
    const variantSelectorNeg = `xebec-variant:not([data-variant-id='${variantId}'])`
    
    Array.from(document.querySelectorAll(variantSelector)).forEach((el) => el.classList.add("selected"))
    Array.from(document.querySelectorAll(variantSelectorNeg)).forEach((el) => el.classList.remove("selected"))
    
    this.handler.updateVariant(
      variantId, 
      this.variantsById[variantId], 
      this.bundlesById[variantId] || []
    )
  }

  getData() {
    return JSON.parse(this.querySelector('[type="application/json"]').textContent);
  }
  
  getVariants() {
    return Array.from(this.querySelectorAll('xebec-variant'));
  }

  getQueryStringVariant() {
    var urlParams = new URLSearchParams(window.location.search);
    var variant = urlParams.get('variant');

    return variant;
  }

  log(id, val) {
    console.debug("XebecVariantOptions::" + id, val)
  }
}

class XebecVariant extends HTMLElement {
  constructor() {
    super();

    this.isSelected = false;
  }

  initVariant(variantData) {
    this.log("variant", variantData);
    this.variantData = variantData;
    
    const variantInfoGrid = document.createElement("div");
    variantInfoGrid.classList.add("variant-info-grid");

    const dotCell = this.buildDotCell()
    const infoCell = this.buildInfoCell(variantData.title);
    const basePriceCell = this.buildBasePriceCell();
    const currentPriceCell = this.buildCurrentPriceCell();
    
    variantInfoGrid.appendChild(dotCell);
    variantInfoGrid.appendChild(infoCell);

    if (currentPriceCell)
      variantInfoGrid.appendChild(currentPriceCell);

    if (basePriceCell) 
      variantInfoGrid.appendChild(basePriceCell)
    
    this.appendChild(variantInfoGrid);
  }

  isAvailable() {
    return this.getAttribute("disabled")
  }

  getId() {
    return this.variantId;
  }

  select() {
    this.log("select", "selecting variant")
    
    this.isSelected = true;
    this.classList.add("selected");
  }

  deselect() {
    this.log("deselect", "deselecting variant")
    
    this.isSelected = false;
    this.classList.remove("selected");
  }

  buildDotCell() {
    const dotCell = document.createElement("div");
    dotCell.classList.add("dot");

    const spacer = document.createElement("div");
    spacer.append("\u00A0");

    dotCell.appendChild(spacer)

    return dotCell;
  }

  buildInfoCell(title) {
    const infoCell = document.createElement("div");
    infoCell.classList.add("info");
    infoCell.textContent = title;

    return infoCell;
  }

  buildBasePriceCell(basePrice) {
    if (!basePrice)
      return null;
    
    const priceCell = document.createElement("div");
    
    priceCell.classList.add("compare-at-price");
    priceCell.textContent = basePrice;

    return priceCell
  }

  buildCurrentPriceCell(currentPrice) {
    if (!currentPrice)
      return null;
    
    const priceCell = document.createElement("div");
    priceCell.classList.add("price");
    priceCell.textContent = currentPrice;

    return priceCell;
  }
  
  log(id, val) {
    console.debug("XebecVariant::" + id, val)
  }
}

customElements.define('xebec-variant', XebecVariant);
customElements.define('xebec-variant-options', XebecVariantOptions);